export default "__VITE_ASSET__BYUJ8g4F__"